import { InfoCircleOutlined, PlusCircleOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import {
    Button,
    Checkbox,
    Col,
    Empty,
    Form,
    Input,
    notification,
    Radio,
    Row,
    Select,
    Space,
    Table,
    Tag,
    Tooltip,
    Upload
} from "antd";
import { useEffect, useState } from "react";
import { 
    getCommandPolicyLocalAccount, 
    addCommandPolicyLocalAccount,
    deleteCommandPolicyLocalAccount 
} from "../../../axios/api.mac.management";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

const { Column } = Table
const { Item } = Form;
interface propsModel {
    policyId: string,
    templateTab: any,
    updatePolicy: () => void,
}

export const MacCommandPolicyLocalAccount = (props: propsModel) => {
    const { policyId, templateTab, updatePolicy } = props
    const [showTable, setShowTable] = useState<number>(0)
    const [dataForm] = Form.useForm()
    const [settingType, setSettingType] = useState<string>();
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }

    useEffect(() => { getDataInfo(); }, [])
    
    const getDataInfo = () => {        
        getCommandPolicyLocalAccount(policyId).then(
            (res) => {
                if (res) {
                    setSettingType(res.settingType);
                    console.log(res);
                    dataForm?.setFieldsValue(res);
                    setShowTable(2)
                }
                else {
                    setSettingType("Create");
                    setShowTable(1)
                }
            },
            () => {
                notification.error({message: t("获取本地账户失败")})                    
            }
        )
    }

    const onSettingTypeSelect = (value: any, option: any) => {
        setSettingType(value);
    };


    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                // const {settingType, scriptId, title, remark, content} = res;
                // var obj = {
                //     sourceType: sourceType,
                //     scriptId: scriptId,
                //     title: title,
                //     remark: remark,
                //     content: content
                // };
                addCommandPolicyLocalAccount(policyId, res).then(
                    () => {
                        updatePolicy();
                        notification.success({ message: t("成功") });
                        getDataInfo();
                    }, 
                    () => {
                        notification.error({ message: t("保存失败") })
                    }
                )
            }
        )
    }

    const deleteTemplateClick = () => {
        deleteCommandPolicyLocalAccount(policyId).then(
            () => {
                updatePolicy();
                notification.success({ message: t("成功") });
                setSettingType("Create");
                dataForm.resetFields();
                getDataInfo();
            },
            () => {
                notification.error({ message: t("删除失败") })
            }
        )
    }

    return (
        <>
            <div>
                <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                    <Col className="templateTitle">{t("本地账户")}</Col>
                </Row>
                <Row><div className="dividerStyle"></div></Row>
                <Row style={{ margin: "16px 16px 16px 0px" }}>
                    {showTable == 1 && (
                        <div>
                            <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                                {t("添加本地账户设置，在设备上执行")}
                            </p>
                            <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                                <Button onClick={() => { addClick(); }} type="primary">
                                    <PlusOutlined /> {t("添加规则")}
                                </Button>
                            </div>
                        </div>
                    )}
                    {showTable == 2 && (
                        <>
                            <Form
                                style={{ width: "50%", marginTop: 36, marginLeft: 45 }}
                                layout="vertical"
                                form={dataForm}
                                labelCol={{ span: 24 }}
                                initialValues={{ settingType: settingType, isAdmin: true, isFileAccess: true }}
                            >
                                <Item label={t("账户设置")} name="settingType"  rules={[{ required: true }]}>
                                    <Select onChange={onSettingTypeSelect}>
                                        <Select.Option value="Create">{t("新建用户")}</Select.Option>
                                        <Select.Option value="ResetPwd">{t("重置密码")}</Select.Option>
                                        <Select.Option value="Delete">{t("删除用户")}</Select.Option>
                                        <Select.Option value="RemoveFileAccess">{t("移除文件保险箱权限")}</Select.Option>
                                        <Select.Option value="UpdateToAdmin">{t("提升至管理员权限")}</Select.Option>
                                        <Select.Option value="UpdateToRegular">{t("降低至普通用户权限")}</Select.Option>
                                    </Select>
                                </Item>
                                <Item label={t("用户名")} name="name"  rules={[{ required: true }]}>
                                    <Input></Input>
                                </Item>
                                {(settingType == "ResetPwd") && <>
                                    <Item label={t("密码")} name="password" rules={[{ required: true }]}>
                                        <Input.Password></Input.Password>
                                    </Item>
                                </>
                                }
                                {(settingType == "Create") && <>
                                    <Item label={t("账户全称")} name="fullName" rules={[{ required: true }]}>
                                        <Input></Input>
                                    </Item>
                                    <Item label={t("密码")} name="password" rules={[{ required: true }]}>
                                        <Input.Password></Input.Password>
                                    </Item>
                                    <Item label={t("密码提示")} name="passwordTips" rules={[{ required: true }]}>
                                        <Input></Input>
                                    </Item>
                                    <Item label={t("目录位置")} name="directoryLocation" rules={[{ required: true }]}>
                                        <Input></Input>
                                    </Item>
                                    <Item label={t("管理员权限")} name="isAdmin" rules={[{ required: true }]}>
                                        <Select>
                                            <Select.Option value={true}>{t("是")}</Select.Option>
                                            <Select.Option value={false}>{t("否")}</Select.Option>
                                        </Select>
                                    </Item>
                                    <Item label={t("文件保险箱权限")} name="isFileAccess" rules={[{ required: true }]}>
                                        <Select>
                                            <Select.Option value={true}>{t("是")}</Select.Option>
                                            <Select.Option value={false}>{t("否")}</Select.Option>
                                        </Select>
                                    </Item>
                                </>
                                }
                            </Form>
                            <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "80%" }}>
                                <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                                <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick();  }}>{t("删除规则")}</Button>
                            </div>
                        </>
                    )}
                </Row>
            </div>
        </>
    )
};